import React from 'react'

import { Box, Text } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/button'
import { Image } from '@chakra-ui/image'

import { useGeoLocation } from '../../../hooks/useGeoLocation'
import { useParking } from '../../../hooks/useParking'
import { useGoogleMap } from '../../../hooks/useGoogleMap'

export function RefreshButton() {
  const { location, userLocation, setUserLocation } = useGeoLocation()
  const { selectMarker } = useGoogleMap()
  const { refetch, isRefetching } = useParking()

  const showRefetchButton = React.useMemo(() => {
    if (isRefetching) {
      return true
    }

    return (
      location.lat !== userLocation.lng && location.lng !== userLocation.lng
    )
  }, [isRefetching, location.lat, location.lng, userLocation.lng])

  const left = React.useMemo(() => {
    return {
      base: isRefetching ? '37%' : '20%',
      mobileMedium: isRefetching ? '40%' : '25%',
      mobileLarge: isRefetching ? '40%' : '28%',
      tablet: isRefetching ? '45%' : '38%',
      computer: isRefetching ? '50%' : '43%',
    }
  }, [isRefetching])

  return (
    <>
      {showRefetchButton && (
        <Box
          left={left}
          zIndex={1}
          position="absolute"
          transform="translateY(-50%)"
          top="40px"
        >
          <Button
            alignItems="center"
            backgroundColor="rgb(255, 255, 255)"
            borderRadius="9999px"
            border="1px solid rgb(215, 215, 224)"
            boxShadow="rgb(152 152 166 / 20%) 0px 7px 8px -4px, rgb(152 152 166 / 14%) 0px 12px 17px 2px, rgb(152 152 166 / 12%) 0px 5px 22px 4px"
            cursor="pointer"
            display="flex"
            height="32px"
            justifyContent="center"
            padding="0px 16px"
            _hover={{
              backgroundColor: 'rgb(255, 255, 255)',
            }}
            _focus={{
              backgroundColor: 'rgb(255, 255, 255)',
            }}
          >
            <Box display={isRefetching ? 'block' : 'none'}>
              <Image
                margin="0px"
                padding="0px"
                src="https://gympass.com/mep-assets/images/commons/map/loading.gif"
                alt="Loading"
              />
            </Box>
            <Box display={isRefetching ? 'none' : 'block'}>
              <Text
                margin="0px"
                padding="0px"
                fontSize="14px"
                lineHeight="20px"
                color="rgb(35, 27, 34)"
                fontWeight="700"
                onClick={async () => {
                  setUserLocation(location)
                  selectMarker(null)

                  await refetch()
                }}
              >
                Pesquisar nesta área
              </Text>
            </Box>
          </Button>
        </Box>
      )}
    </>
  )
}
